export const keepCurrentCoverButtonDataSet = { cy: 'keep-current-cover-button' };
